module.exports = __webpack_public_path__ + "img/relapse-reported.11f302eb.svg";